import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-text-bolder" }
const _hoisted_2 = { class: "uk-grid uk-margin-remove-top" }
const _hoisted_3 = { class: "uk-width-1-2 uk-margin-remove-top uk-flex uk-flex-column uk-text-left" }
const _hoisted_4 = {
  for: "addrLine1",
  class: "uk-form-label"
}
const _hoisted_5 = { class: "uk-width-1-2 uk-margin-remove-top uk-flex uk-flex-column uk-text-left" }
const _hoisted_6 = { class: "uk-grid uk-margin-remove-top" }
const _hoisted_7 = { class: "uk-width-1-3 uk-flex uk-flex-column uk-text-left" }
const _hoisted_8 = {
  for: "addrCity",
  class: "uk-form-label"
}
const _hoisted_9 = { class: "uk-width-1-3 uk-flex uk-flex-column uk-text-left" }
const _hoisted_10 = {
  for: "addrState",
  class: "uk-form-label"
}
const _hoisted_11 = { class: "uk-width-1-3 uk-flex uk-flex-column uk-text-left" }
const _hoisted_12 = {
  for: "addrZip",
  class: "uk-form-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, "Street Address " + _toDisplayString(_ctx.requiredLabel), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.streetAddress) = $event)),
          type: "text",
          id: "addrLine1",
          class: _normalizeClass(["uk-input", { 'uk-form-danger': _ctx.textDanger }])
        }, null, 2), [
          [_vModelText, _ctx.address.streetAddress]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "addrLine2",
          class: "uk-form-label"
        }, "Address line 2", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address.suite) = $event)),
          type: "text",
          id: "addrLine2",
          class: _normalizeClass(["uk-input", { 'uk-form-danger': _ctx.textDanger }])
        }, null, 2), [
          [_vModelText, _ctx.address.suite]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, "City " + _toDisplayString(_ctx.requiredLabel), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.city) = $event)),
          type: "text",
          id: "addrCity",
          class: _normalizeClass(["uk-input uk-form-width-medium uk-width-1-1", { 'uk-form-danger': _ctx.textDanger }])
        }, null, 2), [
          [_vModelText, _ctx.address.city]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, "State " + _toDisplayString(_ctx.requiredLabel), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.state) = $event)),
          type: "text",
          id: "addrState",
          class: _normalizeClass(["uk-input uk-form-width-medium uk-width-1-1", { 'uk-form-danger': _ctx.textDanger }])
        }, null, 2), [
          [_vModelText, _ctx.address.state]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, "Zip " + _toDisplayString(_ctx.requiredLabel), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.zipCode) = $event)),
          type: "text",
          id: "addrZip",
          class: _normalizeClass(["uk-input uk-form-width-medium uk-width-1-1", { 'uk-form-danger': _ctx.textDanger }])
        }, null, 2), [
          [_vModelText, _ctx.address.zipCode]
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
  ]))
}